import InsuranceType from "./components/InsuranceType.vue"
import Message from "./components/Message.vue"

// auto
import VehicleYear from "./components/auto/VehicleYear.vue"
import VehicleMake from "./components/auto/VehicleMake.vue"
import VehicleModel from "./components/auto/VehicleModel.vue"

import VehicleTrimAndVehicleOwnershipType from "./components/auto/VehicleTrimAndVehicleOwnershipType.vue"

import VehiclePrimaryUseTypeAnnualMileageDaysDrivenPerWeekRequestedAutoCoverageType from "./components/auto/VehiclePrimaryUseTypeAnnualMileageDaysDrivenPerWeekRequestedAutoCoverageType.vue"

import AddAnotherVehicle from "./components/auto/AddAnotherVehicle.vue"
import AutoInsuranceLength from "./components/auto/AutoInsuranceLength.vue"
import CurrentAutoInsurer from "./components/auto/CurrentAutoInsurer.vue"
import CurrentAutoInsurerLength from "./components/auto/CurrentAutoInsurerLength.vue"
import NumberOfDrivers from "./components/auto/NumberOfDrivers.vue"

import GenderIsMarriedCreditRating from "./components/GenderIsMarriedCreditRating.vue"

import AccidentsInPast3Years from "./components/auto/AccidentsInPast3Years.vue"
import TicketsInPast3Years from "./components/auto/TicketsInPast3Years.vue"
import DuiNeedsSr22 from "./components/auto/DuiNeedsSr22.vue"
import LicenseStatus from "./components/auto/LicenseStatus.vue"

import CurrentResidenceTypeIsInterestedInHomeInsuranceQuotes from "./components/CurrentResidenceTypeIsInterestedInHomeInsuranceQuotes.vue"

import DateOfBirthNameAddressCityZipCodeEmailPhoneNumber from "./components/DateOfBirthNameAddressCityZipCodeEmailPhoneNumber.vue"

// home
import HomeType from "./components/home/HomeType.vue"
import AddressCityStateZipCode from "./components/AddressCityStateZipCode.vue"
import OwnHome from "./components/home/OwnHome.vue"
import YearHomeBought from "./components/home/YearHomeBought.vue"

import PrimaryResidence from "./components/home/PrimaryResidence.vue"
import HomeSecuritySystem from "./components/home/HomeSecuritySystem.vue"
import HomeClaimsInPast5Years from "./components/home/HomeClaimsInPast5Years.vue"
import CurrentHomeInsurer from "./components/home/CurrentHomeInsurer.vue"
import CurrentHomeDeductibleAndLiability from "./components/home/CurrentHomeDeductibleAndLiability.vue"

import Name from "./components/Name.vue"
import DateOfBirth from "./components/DateOfBirth.vue"
import Email from "./components/Email.vue"
import PhoneNumber from "./components/PhoneNumber.vue"

const steps = {
    Pre: {
        InsuranceType: InsuranceType
    },
    Post: {
        Message: Message
    },
    Auto: {
        VehicleYear,
        VehicleMake,
        VehicleModel,

        VehicleTrimAndVehicleOwnershipType,

        VehiclePrimaryUseTypeAnnualMileageDaysDrivenPerWeekRequestedAutoCoverageType,

        AddAnotherVehicle,
        AutoInsuranceLength,
        CurrentAutoInsurer,
        CurrentAutoInsurerLength,
        NumberOfDrivers,

        GenderIsMarriedCreditRating,

        AccidentsInPast3Years,
        TicketsInPast3Years,
        DuiNeedsSr22,
        LicenseStatus,

        CurrentResidenceTypeIsInterestedInHomeInsuranceQuotes,

        DateOfBirthNameAddressCityZipCodeEmailPhoneNumber
    },
    Home: {
        HomeType,
        AddressCityStateZipCode,
        OwnHome,
        YearHomeBought,
        PrimaryResidence,
        HomeSecuritySystem,
        HomeClaimsInPast5Years,
        CurrentHomeInsurer,
        CurrentHomeDeductibleAndLiability,
        Name,
        DateOfBirth,
        Email,
        PhoneNumber
    }
};

export default {
    functional: true,
    props: {
        type: String,
        step: String
    },
    render(createElement, context) {
        if (!steps[context.props.type][context.props.step]) {
            return createElement(steps["Pre"]["InsuranceType"], context.data, context.childred);
        }
        return createElement(steps[context.props.type][context.props.step], context.data, context.children);
    }
}
